import { render, staticRenderFns } from "./modalPericulosidadeBase.vue?vue&type=template&id=6accbdf9&scoped=true&"
import script from "./modalPericulosidadeBase.vue?vue&type=script&lang=js&"
export * from "./modalPericulosidadeBase.vue?vue&type=script&lang=js&"
import style0 from "./modalPericulosidadeBase.vue?vue&type=style&index=0&id=6accbdf9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6accbdf9",
  null
  
)

export default component.exports